import { ConsentId } from '@/shared/enums';
import { AssetLoader } from '@/shared/utils';
import IpressoEmitter from './ipresso-emitter';

export default async ({ $deferredLoader, $EventBus, $oneTrust, $services, $stats, $storage, $router }) => {
  const info = $services.resolve('info');

  await info.fetch();
  const { ipressoApiScript, ipressoConfiguration, reportingInfo } = info;

  if (!ipressoApiScript || !ipressoConfiguration || !reportingInfo) {
    return;
  }

  const emitter = new IpressoEmitter({ $stats, $oneTrust, $services, $storage, $router });
  $stats.registerEmitter(emitter);

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => {
      if (!$oneTrust.areConsentsAccepted([ConsentId.IPRESSO, ConsentId.STRICTLY_NECESSARY])) {
        return Promise.reject();
      }

      window.ipressoDisplayBanner = (params = {}) => {
        $EventBus.emit('ipressoDisplayBanner', params);
      };

      return new AssetLoader().load([
        { id: 'ipresso', src: ipressoApiScript },
      ], { async: true });
    })
    .then(() => {
      emitter.activate();
    })
    .catch(() => {});
};
